import { render, staticRenderFns } from "./TileDataOMCorridors.vue?vue&type=template&id=74dea3d0"
import script from "./TileDataOMCorridors.vue?vue&type=script&lang=js"
export * from "./TileDataOMCorridors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports